import { css } from "@emotion/react";
import { media } from "styles/breakpoints";
import { theme } from "styles/theme";

export const ModalDownloadStyle = {
  modalContainer: css`
    .ant-modal-content {
      max-height: 220px;
      border-radius: 12px !important;
      overflow: hidden;
      padding: 0px !important;
      background-color: transparent !important;
    }
    .ant-modal-footer {
      display: none !important;
    }
  `,
  formContainer: css`
    display: flex;
    flex-direction: column;
    margin-left: 32px;
    margin-right: 32px;
    margin-top: 32px;
    ${media.md} {
      margin-left: 0;
      margin-right: 0;
    }
  `,
  box: css`
    flex-direction: column;
  `,
  center: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;

    span {
      color: ${theme.colors.white};
      text-transform: capitalize;
    }
  `,
  icon: css`
    font-size: 24px;
    color: ${theme.colors.white};
  `,
  boxBorder: css`
    padding: 8px;
    border: 1px solid ${theme.colors.white};
    border-radius: 32px;
    cursor: pointer;
  `
};
